import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Heart } from '@phosphor-icons/react';
import ExYuMap from '../components/ExYuMap';
import { useLang } from '../contexts/LanguageContext';

export default function LandingPage() {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();
  const { t } = useLang();

  const handleContinue = () => {
    if (selected) {
      navigate('/onboarding', { state: { heritage: selected } });
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden"
      style={{
        backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/30562ac1-6cb8-40db-b89b-be786ceb71ff/images/b6e93548f6284f1e6ff426330f7c166e29890a4ff25926fc64207adc64cd1a22.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
      data-testid="landing-page"
    >
      <div className="absolute inset-0 bg-[#060A1A]/85" />

      <motion.div
        className="relative z-10 text-center max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="flex items-center justify-center gap-3 mb-6">
          <Heart weight="fill" size={36} className="text-[#D4AF37]" />
          <h1 className="text-5xl md:text-6xl font-light tracking-tight text-white font-['Outfit']">
            Yu<span className="text-gold-gradient font-bold">Blink</span>
          </h1>
        </div>

        <p className="text-[#9EABCE] text-base md:text-lg mb-2 font-['Manrope']">
          {t('landing_tagline')}
        </p>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37] mb-10">
          {t('select_heritage')}
        </p>

        <ExYuMap onSelect={setSelected} selected={selected} />

        <motion.button
          onClick={handleContinue}
          disabled={!selected}
          data-testid="landing-continue-btn"
          className={`mt-8 inline-flex items-center gap-3 px-8 py-4 rounded-xl text-base font-bold transition-all duration-300 ${
            selected
              ? 'btn-gold'
              : 'bg-white/5 text-[#9EABCE]/40 cursor-not-allowed border border-white/5'
          }`}
          whileHover={selected ? { scale: 1.03 } : {}}
          whileTap={selected ? { scale: 0.98 } : {}}
        >
          {t('continue')}
          <ArrowRight size={20} weight="bold" />
        </motion.button>

        <div className="mt-8 pt-6 border-t border-white/5 max-w-xs mx-auto">
          <button
            onClick={() => navigate('/auth')}
            data-testid="landing-login-btn"
            className="text-[#9EABCE] hover:text-[#D4AF37] text-sm font-semibold tracking-wide transition-colors"
          >
            {t('already_have_account')}
          </button>
        </div>
      </motion.div>
    </div>
  );
}
